var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "720px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.currentRules,
            "label-width": "90px",
          },
        },
        [
          _vm.mode === "create"
            ? _c(
                "el-form-item",
                { attrs: { label: "appid", prop: "appid" } },
                [
                  _c("DynamicOption", {
                    attrs: {
                      placeholder: "appid/全部渠道",
                      singleSelect: true,
                      params: _vm.searchOptions,
                    },
                    model: {
                      value: _vm.form.appid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "appid", $$v)
                      },
                      expression: "form.appid",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.mode === "create"
            ? _c(
                "el-form-item",
                { attrs: { label: "UID", prop: "uid" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入UID" },
                    model: {
                      value: _vm.form.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "uid", $$v)
                      },
                      expression: "form.uid",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "文件", prop: "file" } },
            [
              _c(
                "el-upload",
                {
                  attrs: {
                    action: "",
                    "http-request": _vm.doUpload,
                    "list-type": "text",
                    "show-file-list": true,
                    "file-list": _vm.fileList,
                    limit: 3,
                    accept: ".png,.jpg",
                  },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("点击上传文件"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "故障描述", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入故障描述",
                },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "note" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 2, placeholder: "请输入备注" },
                model: {
                  value: _vm.form.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }